import { useEffect, useState } from "react";
import "./style/recruitmentForm.css";
import axios from "axios";
import { apiUrl } from "../config/api";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function RecruitmentForm({ web_job_id = "123456" }) {
  const { lang } = useParams();
  const { t, i18n } = useTranslation("recruitment");
  const [formData, setFormData] = useState({
    lastName: "",
    firstName: "",
    email: "",
    phone: "",
    web_job_id: Number(web_job_id),
    cv: null,
    consent: false,
  });

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    let fieldValue;

    if (type === "checkbox") fieldValue = checked;
    else if (type === "file") fieldValue = files[0];
    else fieldValue = value;

    setFormData((prev) => ({ ...prev, [name]: fieldValue }));

    if (name === "cv") setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.cv) {
      setError(t("form.cvError"));
      toast.error(t("form.cvError"));
      return;
    }

    const reader = new FileReader();
    reader.onload = async () => {
      const cvBase64 = reader.result.split(",")[1];
      setLoading(true);

      try {
        const response = await axios.post(
          apiUrl("/api/recruitment/apply"),
          {
            jsonrpc: "2.0",
            method: "call",
            params: {
              name: `${formData.lastName} ${formData.firstName}`,
              email: formData.email,
              phone: formData.phone,
              web_job_id: formData.web_job_id,
              cv_file: cvBase64,
            },
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        console.log("Response:", response.data);
        toast.success(t("form.success"), {
          position: "top-right",
          autoClose: 5000,
          style: { fontSize: "14px" },
        });
        setFormData({
          lastName: "",
          firstName: "",
          email: "",
          phone: "",
          web_job_id,
          cv: null,
          consent: false,
        });
      } catch (err) {
        console.error(err);
        toast.error(t("form.submitError"), {
          position: "top-right",
          autoClose: 5000,
          style: { fontSize: "14px" },
        });
      } finally {
        setLoading(false);
      }
    };

    reader.readAsDataURL(formData.cv);
  };

  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  return (
    <div className="form-container">
      <h2 className="title">{t("form.title")}</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-grid">
          <input
            type="text"
            name="lastName"
            placeholder={t("form.lastName")}
            value={formData.lastName}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="firstName"
            placeholder={t("form.firstName")}
            value={formData.firstName}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="email"
            placeholder={t("form.email")}
            value={formData.email}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="phone"
            placeholder={t("form.phone")}
            value={formData.phone}
            onChange={handleChange}
            required
            pattern="\+?\d{8,15}"
            title={t("form.phoneError")}
            maxLength={8}
          />
        </div>

        <div>
          <h3 className="title2">{t("form.cvTitle")}</h3>
        </div>
        <div className={`file-upload ${error ? "error-border" : ""}`}>
          <input type="file" name="cv" id="cvUpload" onChange={handleChange} />
          <label htmlFor="cvUpload">
            {formData.cv ? formData.cv.name : t("form.cvPlaceholder")}
            <p>Maximum upload size: 20MB</p>
          </label>
        </div>
        {error && <div className="error-message">{t("form.cvError")}</div>}

        <div className="checkbox">
          <input
            type="checkbox"
            name="consent"
            className="checkbox-input"
            checked={formData.consent}
            onChange={handleChange}
            required
          />
          <p>{t("form.consent")}</p>
        </div>

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? t("form.submitting") : t("form.submit")}
        </button>
      </form>

      {/* Toast container заавал энд байрлана */}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}
